import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import { Box, CircularProgress } from '@material-ui/core'
import gql from 'graphql-tag'
import dynamic from 'next/dynamic'
import styled from 'styled-components'
import {
  CoverLetterItemMobileBody_CoverLetterFragment,
  CoverLetterItemMobileBody_CurrentUserFragment,
} from 'generated/graphql'
import { getQueryParams } from '../CoverLetterScreen/CoverLetterList/CoverLetterListContent'
import {
  SearchState,
  useSearchStateContext,
} from '../CoverLetterScreen/useSearchState'
import CoverLetterDetail from './CoverLetterDetail'

gql`
  fragment CoverLetterItemMobileBody_coverLetter on CoverLetter {
    id
    isScrapped
    organizationName
    role
    ...CoverLetterUtils_getPassedAtText_coverLetter
    ...CoverLetterDetail_coverLetter
  }
  fragment CoverLetterItemMobileBody_currentUser on User {
    id
    ...CoverLetterDetail_currentUser
  }
`

const SideBar = dynamic(() => import('./SideBar'), {
  ssr: false,
  loading: function SideBarLoading() {
    return (
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={3}
      >
        <CircularProgress />
      </Box>
    )
  },
})

interface CoverLetterItemMobileBodyProps {
  coverLetter?: CoverLetterItemMobileBody_CoverLetterFragment | null
  currentUser?: CoverLetterItemMobileBody_CurrentUserFragment | null
  highlight?: string[] | null | undefined
}

const getListLink = (context: SearchState) => {
  const queryString = getQueryParams(context)
  return `/cover-letter/search?${queryString}`
}

const CoverLetterItemMobileBody: FC<CoverLetterItemMobileBodyProps> = ({
  coverLetter,
  currentUser,
  highlight,
}) => {
  const context = useSearchStateContext()
  const listLink = getListLink(context)

  return (
    <Wrapper>
      <CoverLetterDetail
        listLink={listLink}
        coverLetter={coverLetter ?? undefined}
        currentUser={currentUser ?? undefined}
        highlight={highlight}
      />

      <LazyLoad once>
        <SideBar currentUser={currentUser ?? undefined} />
      </LazyLoad>
    </Wrapper>
  )
}

export default CoverLetterItemMobileBody

const Wrapper = styled.div`
  overflow: hidden;
`
